import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AddSearchModal} from './add-search.modal';

type Props = {
    onAdd: () => void,
    conferenceId: number,
};

export const AddSearch = ({onAdd, conferenceId}: Props) => {
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <Button variant="Type.SECONDARY" onClick={onClick}>Add Search</Button>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <AddSearchModal
                    conferenceId={conferenceId}
                    onClose={onClose}
                    onAdd={onAdd}
                />
            </Dialog>
        </>
    );
};
